// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useState, useEffect} from 'react';
import {Settings_context} from '../settings_ctx';
import {use_screen} from '../lib/screen_util';
import {Button} from '../../../shared/button';
import {use_download} from '../shared/use_download';
import {Editor} from '../../../shared/editor/editor';
import styles from './download_browser_banner.module.less';
import user_agent from '/util/user_agent.js';

const is_win = user_agent.guess().os=='windows';

interface i_download_browser_banner_props {
    title: string;
    subtitle: string;
    button_text: string;
    render_images: boolean;
}

export const Download_browser_banner = (
props: i_download_browser_banner_props)=>{
    const {title, subtitle, button_text, render_images = true} = props;
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    const [window_width, set_window_width] = useState(0);
    const {download_br} = use_download();
    useEffect(()=>set_window_width(width), [width]);
    const on_download = ()=>{
        download_br({cb: ()=>{
          setTimeout(()=>{
              window.location.href =
                  'https://hola.org/after_download?s=install&browser=1';
          }, 1000);
        }});
    };
    const _title = is_win ? title :
        'Hola Browser. Get truly Global Access to all your favorite content.';
    return <div className={styles.browser_top}>
      <div className={styles.browser_text}>
        <h1 className={styles.page_header}>{_title}</h1>
        <p className={theme.u3}>{subtitle}</p>
        <Button on_click={on_download} caption={button_text}
          color="black2023"
          size={window_width >= 992 ? 'lg' : 'md'}
          arrow txt_colored />
        {render_images && <><div className={styles.browser_bg} />
        <div className={styles.browser_interface} /></>}
      </div>
    </div>;
};

interface i_download_browser_banner_editor_props {
  value: i_download_browser_banner_props;
  on_change: (new_val: i_download_browser_banner_props)=>void;
}

export const Download_browser_banner_editor = (
{value, on_change}: i_download_browser_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title (h1)', type: 'text'},
        {key: 'subtitle', label: 'Subtitle', type: 'text'},
        {key: 'button_text', label: 'Button text', type: 'text'},
        {key: 'render_images', label: 'Render images below', type: 'boolean'},
      ]}/>;
};
